// extracted by mini-css-extract-plugin
export default {"productBrandDescription":"Uz8ffrezjPz9XN2bUqwS-ProductBrandDescription-productBrandDescription"};